import { useCallback, useState } from "react";

const useTwoWayBinding = <T extends unknown>(
  initialValue: T,
): [T, (event: React.ChangeEvent<{ value: unknown }>) => void, () => void] => {
  const [value, setValue] = useState<T>(initialValue);

  const handleValueChange = useCallback((event: React.ChangeEvent<{ value: unknown }>) => {
    setValue(event.target.value as T);
  }, []);

  const resetValue = useCallback(() => {
    setValue(initialValue);
  }, [initialValue]);

  return [value, handleValueChange, resetValue];
};

export { useTwoWayBinding };
